import * as React from 'react';

function SvgPriceTagOutline(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.6, d: "M19.923 2.809H14.49a.64.64 0 00-.451.185L3.18 13.851a1.275 1.275 0 000 1.799l5.171 5.17a1.275 1.275 0 001.8 0L21.005 9.967a.639.639 0 00.185-.45V4.08a1.267 1.267 0 00-1.268-1.272v0z" }),
        React.createElement("path", { stroke: "currentColor", strokeWidth: 1.6, d: "M17.055 8.323a1.379 1.379 0 110-2.757 1.379 1.379 0 010 2.757z" })));
}

export default SvgPriceTagOutline;
